export default __webpack_public_path__ + "static/media/gdp_poli_no_Background.dde5be14.png";